<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-bottom-align`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43 41a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1v-2a1 1 0 011-1h38zM23.998 3h2a1 1 0 01.994.883l.006.117v27.728l8.609-8.608a1 1 0 011.32-.084l.094.084 1.414 1.414a1 1 0 01.083 1.32l-.083.094-12.728 12.728a1 1 0 01-1.32.083l-.094-.083-12.728-12.728a1 1 0 01-.083-1.32l.083-.094 1.414-1.414a1 1 0 011.32-.084l.094.084 8.605 8.606V4a1 1 0 01.884-.993L23.998 3h2-2z"/></svg>
</template>
<script>

export default {
  name: 'IconBottomAlign',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
